




























































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Emit, Model, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { OptionGroupResourcePayload } from '@/models'

import SwitchListItem from './SwitchListItem.vue'

@Component({
  components: {
    ListItem,
    SwitchListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class OptionGroupForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: OptionGroupResourcePayload | null

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Boolean, default: false })
  readonly isLocked!: boolean

  @Prop({ type: Boolean, default: false })
  readonly lastDivider!: boolean

  isValid = false

  title = ''
  maxLength: number | string | null = null
  isRequired = false
  isActive = true

  maxLengthPlaceholderIntervalId: NodeJS.Timeout | null = null

  @Ref()
  maxLengthField!: Vue

  @Watch('data', { immediate: true })
  onDataChange () {
    if (this.data === null) {
      this.title = ''
      this.maxLength = null
      this.isRequired = false
      this.isActive = true
    } else {
      this.title = this.data.title
      this.maxLength = this.data.maxlength
      this.isRequired = this.data.required
      this.isActive = this.data.active
    }
  }

  @Watch('title')
  onTitleChange () {
    this.updateModel()
  }

  @Watch('maxLength')
  onMaxLengthChange () {
    if (this.maxLength === '') {
      this.maxLength = null
    } else {
      this.updateModel()
    }
  }

  @Watch('isRequired')
  onIsRequiredChange () {
    this.updateModel()
  }

  @Watch('isActive')
  onIsActiveChange () {
    this.updateModel()
  }

  created () {
    Vue.nextTick(() => {
      const maxLengthInput: HTMLInputElement | undefined = this.maxLengthField
        ? this.maxLengthField.$el.getElementsByTagName('input')[0]
        : undefined

      if (maxLengthInput) {
        this.maxLengthPlaceholderIntervalId = setInterval(
          () => { maxLengthInput.placeholder = 'Quantos quiser' },
          50
        )
      }
    })
  }

  beforeDestroy () {
    if (this.maxLengthPlaceholderIntervalId !== null) {
      clearInterval(this.maxLengthPlaceholderIntervalId)
    }
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  @Emit('update:isValid')
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  @Emit('change')
  updateModel (): OptionGroupResourcePayload {
    return {
      groupId: this.itemGroupId,
      title: this.title,
      sequence: null,
      maxlength: this.maxLength as number | null,
      required: this.isRequired,
      active: this.isActive
    }
  }

  submit () {
    if (this.isValid) {
      this.$emit('submit')
    }
  }
}
